module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"mobile-filters-button":{"title":"Filter"}},"de":{"version":1,"mobile-filters-button":{"title":"Filter"}},"en":{"mobile-filters-button":{"title":"Filter"}},"fr":{"mobile-filters-button":{"title":"Filtre"}},"nl":{"mobile-filters-button":{"title":"Filters"}},"pl":{"mobile-filters-button":{"title":"Filtry"}}}')
  delete Component.options._Ctor
}
